import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Form } from "react-router";
import CustomButton from "../Button";
import { showToast } from "../../utils/helpers";
import { useDispatch } from "react-redux";
import { executeWithdrawalAction } from "../../Services/Store/Actions/AuthActions";

interface RequestPayoutModalType {
  show: boolean;
  onClose: Function;
  onSuccess?: Function;
}

const RequestPayoutModal: React.FC<RequestPayoutModalType> = ({
  show,
  onClose,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const amountRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState<number | null>(null);

  const validateForm = () => {
    let isErr = false;

    if (!amount) {
      if (amountRef.current) {
        amountRef.current.focus();
      }
      showToast("error", "Please enter amount to withdraw");
      isErr = true;
    } else if (amount < 10) {
      if (amountRef.current) {
        amountRef.current.focus();
      }
      showToast("error", "Withdrawal amount should be atleast $10");
      isErr = true;
    }

    return isErr;
  };

  const requestWithdrawal = () => {
    const isErr = validateForm();

    if (!loading && !isErr) {
      setLoading(true);

      executeWithdrawalAction({ amount }, dispatch)
        .then((res) => {
          showToast(res.type, res.message);

          if (res.type === "success" && onSuccess) {
            onSuccess();

            // setTimeout(() => {
            onClose();
            //}, 500);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <Modal show={show} onHide={() => onClose()}>
      <Modal.Header closeButton>Request Withdrawal</Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            requestWithdrawal();
          }}
        >
          <p className="required-note">
            <span className="required-star">*</span> Required
          </p>
          <div className="form-group">
            <label>
              Amount<span className="required-star">*</span>
            </label>
            <input
              ref={amountRef}
              type="number"
              name="name"
              value={amount ? amount : ""}
              onChange={(e) => setAmount(parseFloat(e.target.value))}
              className="form-control"
              placeholder="Please enter amount"
            />
          </div>

          <CustomButton
            isLoading={loading}
            title="Submit"
            onClick={() => requestWithdrawal()}
          />
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default RequestPayoutModal;
